import { render, staticRenderFns } from "./AntecipacaoForm.vue?vue&type=template&id=5aab002d&scoped=true"
import script from "./AntecipacaoForm.vue?vue&type=script&lang=ts"
export * from "./AntecipacaoForm.vue?vue&type=script&lang=ts"
import style0 from "./AntecipacaoForm.vue?vue&type=style&index=0&id=5aab002d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab002d",
  null
  
)

export default component.exports